// src/portfolioData.js

import proj1 from '../assets/Portfolio1.png';
import proj2 from '../assets/Portfolio1.png';
import proj3 from '../assets/Portfolio1.png';

export const portfolioItems = [
  {
    id: 'company1',
    title: 'Stripe',
    description:
      'An epic journey across forgotten kingdoms — we shaped the world, lore and player experience.',
    image: proj1,
    role: 'Worldbuilding & Creative Direction',
    url: 'https://stripe.com'   
  },
  {
    id: 'company2',
    title: 'Dragonspire',
    description:
      'A high-fantasy tactics game where every decision carves destiny. Our team led narrative + branding.',
    image: proj2,
    role: 'Narrative Design & Branding',
    url: 'https://stripe.com'   // 👈 THIS MUST EXIST
  },
  {
    id: 'company3',
    title: 'Realms of Dawn',
    description:
      'An MMO where myth meets strategy. We built the core identity and go-to-market storytelling.',
    image: proj3,
    role: 'Brand Identity & Launch Strategy',
    url: 'https://stripe.com'   // 👈 THIS MUST EXIST
  }
];
